export function buildCheckoutFollowupWaivers(
  waiversMap,
  items,
  scheduledWorkKeyFn,
) {
  const waivers = [];
  for (const [waiverKey, data] of Object.entries(waiversMap || {})) {
    const reason = typeof data?.reason === "string" ? data.reason.trim() : "";
    if (!data?.waived || !reason) continue;
    const item = (items || []).find((candidate) => scheduledWorkKeyFn(candidate) === waiverKey);
    const visitId = item?.procedure_visit_id;
    if (!visitId) continue;
    waivers.push({
      procedure_visit_id: visitId,
      waived: true,
      reason,
    });
  }
  return waivers;
}

export function legacyFollowupWaiverRpcInput(waiver) {
  return {
    p_procedure_visit_id: waiver.procedure_visit_id,
    p_waived: true,
    p_reason: waiver.reason,
  };
}
